export default __webpack_public_path__ + "static/media/mo_premium_02.159d6577.jpg";